import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { formatCurrency } from '@fortress-technology-solutions/fortress-component-library/utils';
import {
  Divider,
  List,
  ListItemText,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { SectionText } from '@fortress-technology-solutions/fortress-component-library/Molecules_Portal';
import CollapsedCard from 'components/Organisms/CollapsedCard';
import useAsyncPrequalifyOptions from 'pages/ChooseHousehold/hooks';

const AffordaResultsIneligible = () => {
  const intl = useIntl();
  const [propParamError, setPropParamError] = useState('');

  const prequalifyOptions = useAsyncPrequalifyOptions(setPropParamError);

  return (
    <>
      <SectionText
        title={intl.formatMessage({ id: 'afforda.resultsIneligible.title' })}
        description={intl.formatMessage({
          id: 'afforda.resultsIneligible.description',
        })}
        secondaryDescription={intl.formatMessage({
          id: 'afforda.resultsIneligible.secondaryDescription',
        })}
      />
      <Divider sx={{ width: '100%', marginY: 2 }} />

      {!propParamError && prequalifyOptions && (
        <CollapsedCard
          titleVariant={'labelLarge'}
          title={
            <FormattedMessage
              id={'afforda.resultsIneligible.maximumIncomeLimits'}
            />
          }
        >
          <List
            sx={{
              textAlign: 'left',
            }}
          >
            {prequalifyOptions.map(({ id, value, label }, index) => (
              <ListItemText
                key={`limit-${index}`}
                primary={
                  <FormattedMessage id={`afforda.resultsIneligible.${id}`} />
                }
                primaryTypographyProps={{ variant: 'labelLarge' }}
                secondary={formatCurrency(value)}
                secondaryTypographyProps={{ variant: 'bodyMedium' }}
                sx={{ paddingY: 1 }}
              />
            ))}
          </List>
        </CollapsedCard>
      )}
    </>
  );
};

export default AffordaResultsIneligible;
